import {useSelector} from 'react-redux';
import Selector from '../../../../../../selectors/pages/home/facebook_boost';
import ModalsLib from '../../../../../../lib/modals';

export default () => {
    const {isAuth} = useSelector(Selector);

    return (
        <div className="slide facebook size-params">
            <div className="size-params-layer layer0"><div className="facebook-icon"></div></div>
            <div className="layer-margin size-params slide-details">
                <div className="title">
                    FREE DAILY<br/>BONUSES
                </div>
                <div className="descriptions-short">Join our Facebook community and unlock exclusive rewards available only to followers.</div>
                <div className="details">
                    <div className="button" onClick={e => {
                        // if(isAuth)
                        //     ModalsLib.open('facebook')
                        // else
                        //     ModalsLib.open('signin')
                        window.open('https://www.facebook.com/groups/1250969826568579/', '_blank')
                    }}>Get Rewards</div>
                </div>
            </div>
        </div> 
    )
} 